import React from 'react';
import { SettingsContext } from '../SettingsContext';
export function useSettings() {
    var value = React.useContext(SettingsContext);
    // if (!SettingsContext.ready && SettingsContext.readyPromise) {
    // // NOTE that in this case your app should be wrapped with Suspense
    //   throw SettingsContext.readyPromise;
    // }
    return value;
}
//# sourceMappingURL=useSettings.js.map